<template>
  <div
    class="estimate-search-list-category"
  >
    <template
      v-for="(displacementBikes, i) in displacementBikesList"
      :key="`estimate-search-list-category${i}`"
    >
      <div v-if="displacementBikes && displacementBikes.list && displacementBikes.list.length > 0">
        <h3
          class="estimate-search-list-category__title"
          v-text="displacementBikes.title"
        />
        <estimate-search-list
          :bike-list="displacementBikes.list"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import EstimateSearchList from './EstimateSearchList.vue'

export default defineComponent({
  name: 'EstimateSearchListCategory',
  components: {
    EstimateSearchList,
  },
  props: {
    displacementBikesList: {
      type: Array,
      required: true,
      default: () => [],
    }
  },
})

</script>